'use client';

export default function MiniAppError({ reset }: { reset: () => void }) {
  return <main className="empty-state" role="alert"><h3>暫時無法載入</h3><p>請確認網路連線後再試一次。</p><button type="button" className="app-button" onClick={reset}>重新載入</button></main>;
}
